import React from 'react'
import loadable from '@loadable/component'
import clsx from 'clsx'
import { ReactComponent as Check } from '@/assets/icons/check_purple_circle.svg'
import { ReactComponent as PurpleCircle } from '@/assets/icons/purple_full_circle.svg'
import { ReactComponent as BigYellowCircle } from '@/assets/icons/half_yellow_circle.svg'
import { ReactComponent as SmallYellowCircle } from '@/assets/icons/advatages-grid-item-bg-2.svg'

import { ReviewsSlider } from '@/components/organisms/SectionSalesCall/components/ReviewsSlider'
import { SectionSalesCallProps } from '@/components/organisms/SectionSalesCall/types'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'
import * as styles from './SectionSales.module.css'

const InlineWidget = loadable(() =>
  import('react-calendly').then((module) => ({
    default: module.InlineWidget
  }))
)
export function SectionSalesCall({ heading, subheading, calendly_url, list, reviews }: SectionSalesCallProps) {
  return (
    <section
      className={clsx(
        styles.wrapper,
        'relative pt-24 pb-48 netbook:py-64 bg-no-repeat bg-contain bg-center-bottom netbook:bg-center'
      )}
    >
      <SmallYellowCircle className="hidden netbook:block absolute top-1/2 right-24 z-10" />
      <BigYellowCircle className="hidden netbook:block absolute scale-150 top-32 right-16 rotate-180 z-10" />
      <PurpleCircle className="hidden netbook:block absolute -bottom-32 -left-72 z-10" />
      <div className="mx-auto max-w-screen-desktop  px-24 netbook:px-90 grid grid-cols-1 netbook:grid-cols-2 netbook:gap-x-24">
        <div className="row-start-1 netbook:col-span-1">
          {heading && (
            <h1 className="text-headingL-mobile text-text-dark-900 font-poppins font-bold mb-16 netbook:text-headingL mx-auto">
              {heading}
            </h1>
          )}
          {subheading && <Paragraph className="text-bodyL text-text-dark-600 mb-24 mx-auto ">{subheading}</Paragraph>}
        </div>

        {list && (
          <div className="mb-48 netbok:mb-40 row-start-3 netbook:col-span-1 netbook:row-start-2">
            <p className="text-bodyL font-bold mb-16 text-text-dark-900">{list[0].title}</p>
            <ul className="text-text-brand-darker font-bold flex flex-col gap-16">
              {list[0].text_items.map((item: any) => (
                <li key={item._uid} className="relative flex gap-16 desktop:items-center text-bodyL">
                  <Check className="min-w-24 mt-[0.3em] desktop:mt-0" />
                  {item.text}
                </li>
              ))}
            </ul>
          </div>
        )}

        {reviews && reviews.length > 0 && (
          <ReviewsSlider
            reviews={reviews}
            classname="row-start-4 netbook:col-span-1 netbook:row-start-3 min-h-208 netbook:min-h-192"
          />
        )}

        {calendly_url && (
          <div
            className={clsx(
              'z-[15] max-[700px]:shadow-megamenu netbook:shadow-megamenu rounded-2xl overflow-hidden mb-24 netbook:ml-24 row-start-2 netbook:col-span-1 netbook:col-start-2 netbook:row-start-1 netbook:row-span-3 netbook:w-[400px] netbook:h-fit max-[700px]:bg-white netbook:bg-white',
              styles.calendly
            )}
          >
            <InlineWidget url={calendly_url} pageSettings={{ hideGdprBanner: true, hideEventTypeDetails: true }} />
          </div>
        )}
      </div>
    </section>
  )
}
